import { useEffect } from "react";

/**
 * Hook pour bloquer/débloquer le scroll du body
 * @param isLocked - Boolean pour indiquer si le scroll doit être bloqué
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (typeof document === "undefined") return;

    if (isLocked) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLocked]);
};
